var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRewardOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66732 19.708C4.74332 19.6533 3.94065 19.06 3.65398 18.2013C2.93398 16.0427 3.18065 16.3773 1.27265 15.052C0.672651 14.636 0.333984 13.9747 0.333984 13.2907C0.333984 13.064 0.369984 12.836 0.447318 12.612C1.18465 10.464 1.18598 10.8787 0.447318 8.71867C0.369984 8.49733 0.333984 8.268 0.333984 8.04267C0.333984 7.35733 0.672651 6.69733 1.27265 6.28C3.17932 4.95733 2.93265 5.292 3.65398 3.12933C3.95398 2.22933 4.82465 1.62133 5.80732 1.62133H5.81398C8.16732 1.62933 7.74865 1.76667 9.66598 0.417333C10.0633 0.138667 10.5313 0 11.0007 0C11.47 0 11.938 0.138667 12.3353 0.417333C14.2393 1.756 13.8287 1.62933 16.1873 1.62133H16.194C17.1767 1.62133 18.0473 2.22933 18.3486 3.12933C19.0686 5.288 18.8167 4.95333 20.73 6.28C21.3287 6.696 21.6673 7.35733 21.6673 8.04133C21.6673 8.26667 21.6327 8.49733 21.554 8.71867C20.818 10.868 20.8153 10.4547 21.554 12.612C21.6327 12.836 21.6673 13.0653 21.6673 13.2907C21.6673 13.9747 21.3287 14.636 20.73 15.052C18.8167 16.38 19.0686 16.0453 18.3486 18.2013C18.0606 19.0587 17.2593 19.6533 16.334 19.708V32L11.0567 28L5.66732 32V19.708ZM18.6193 10.6667C18.6193 6.46 15.21 3.048 11.0007 3.048C6.79398 3.048 3.38198 6.46 3.38198 10.6667C3.38198 14.8733 6.79398 18.2853 11.0007 18.2853C15.21 18.2853 18.6193 14.8733 18.6193 10.6667ZM11.0007 5.33333C8.06065 5.33333 5.66732 7.72533 5.66732 10.6667C5.66732 13.608 8.06065 16 11.0007 16C13.942 16 16.334 13.608 16.334 10.6667C16.334 7.72533 13.942 5.33333 11.0007 5.33333Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardOptions);
export default __webpack_public_path__ + "static/media/reward-options.c928b9a64ef6fb1cc162b4171bb319cf.svg";
export { ForwardRef as ReactComponent };